export default "__VITE_ASSET__BGlRUFL4__"